import { QueryParams } from '../../constants/queryParams';
import { editDate } from '../../utils/dateUtil';

/**
 * 検索条件保存用リクエストデータの作成
 * @param {object} reqData フォームデータ
 * @param {string} wserdt 時間
 * @returns フォームデータ
 */
export function createSaveParam(reqData: QueryParams, wserdt: string) {
  const param = {
    SP_ltype: 'sc',
    SP_CC_wserdt: wserdt,
  };

  Object.keys(reqData).forEach((key) => {
    if (key === 'wsernm') {
      param[`SP_CC_${key}`] = reqData[key];
    } else {
      param[`SP_SC_${key}`] = reqData[key];
    }
  });

  return param;
}

/**
 * form送信時に送る検索条件データを作成
 * @param {QueryParams} data
 */
export function makeSendConditionParam(data: QueryParams) {
  const clonedData = { ...data };
  // 送信不要な情報を削除
  delete clonedData.usrclk;
  // 検索条件登録パラメータ生成
  const param = createSaveParam(clonedData, editDate());

  return { ...clonedData, ...param };
}

/**
 * 検索条件名の作成
 * @returns {string} 検索条件名（例：「2022年7月1日の検索条件」）
 */
export function createSearchConditionName() {
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth() + 1;
  const date = today.getDate();

  return `${year}年${month}月${date}日の検索条件`;
}
